import React from "react";
import { IdcardOutlined, CalendarOutlined, CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { Skeleton } from "antd";

const SubscriptionSummaryBanner = ({ seatData, loading }) => {
  if (loading) {
    return (
      <div className="installer-sub-banner">
        <div className="banner-left">
          <div className="icon-wrapper" style={{ background: "transparent", border: "none" }}>
            <Skeleton.Avatar active shape="square" size={48} style={{ borderRadius: "14px" }} />
          </div>
          <div className="info-text" style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <Skeleton.Input active size="small" style={{ width: 160, height: 18, borderRadius: "4px" }} />
            <Skeleton.Input active size="small" style={{ width: 120, height: 13, borderRadius: "4px" }} />
          </div>
        </div>

        <div className="banner-stats">
          <div className="stat-item">
            <span style={{ display: "block", marginBottom: 6 }}>
              <Skeleton.Input active size="small" style={{ width: 68, height: 11 }} />
            </span>
            <Skeleton.Input active size="small" style={{ width: 26, height: 22 }} />
          </div>
          <div className="stat-item">
            <span style={{ display: "block", marginBottom: 6 }}>
              <Skeleton.Input active size="small" style={{ width: 68, height: 11 }} />
            </span>
            <Skeleton.Input active size="small" style={{ width: 26, height: 22 }} />
          </div>
          <div className="stat-item">
            <span style={{ display: "block", marginBottom: 6 }}>
              <Skeleton.Input active size="small" style={{ width: 85, height: 11 }} />
            </span>
            <Skeleton.Input active size="small" style={{ width: 34, height: 22 }} />
          </div>
          <div className="stat-item">
            <span style={{ display: "block", marginBottom: 6 }}>
              <Skeleton.Input active size="small" style={{ width: 45, height: 11 }} />
            </span>
            <Skeleton.Input active size="small" style={{ width: 95, height: 18 }} />
          </div>
          <div className="stat-item">
            <span style={{ display: "block", marginBottom: 6 }}>
              <Skeleton.Input active size="small" style={{ width: 70, height: 11 }} />
            </span>
            <Skeleton.Input active size="small" style={{ width: 85, height: 18 }} />
          </div>
        </div>
      </div>
    );
  }

  const totalSeats = seatData?.seats?.total_seats ?? 0;
  const usedSeats = seatData?.seats?.used_seats ?? 0;
  const remainingSeats = seatData?.seats?.remaining_seats ?? Math.max(0, totalSeats - usedSeats);
  const planName = seatData?.plan_name || "Installer Pro Access";
  const isSubscribed = seatData?.is_subscribed;

  // Find earliest renews_at or ends_at from active subscriptions
  let renewsOn = "-";
  if (seatData?.subscriptions && seatData.subscriptions.length > 0) {
    const activeSub = seatData.subscriptions.find((s) => s.renews_at) || seatData.subscriptions[0];
    renewsOn = activeSub?.renews_at || activeSub?.ends_at || "-";
  }

  return (
    <div className="installer-sub-banner">
      <div className="banner-left">
        <div className="icon-wrapper">
          <IdcardOutlined />
        </div>
        <div className="info-text">
          <h4 className="title">Installer Subscription</h4>
          <p className="subtitle">
            {isSubscribed ? (
              <>
                <span className="active-dot"></span>
                You're on <strong>{planName}</strong>
              </>
            ) : (
              "No active subscription"
            )}
          </p>
        </div>
      </div>

      <div className="banner-stats">
        <div className="stat-item">
          <span className="stat-label">Total Seats</span>
          <span className="stat-value">{totalSeats}</span>
        </div>

        <div className="stat-item">
          <span className="stat-label">Used Seats</span>
          <span className="stat-value">{usedSeats}</span>
        </div>

        <div className="stat-item">
          <span className="stat-label">Available Seats</span>
          <span
            className={`stat-value available ${remainingSeats > 0 ? "has-seats" : "no-seats"}`}
          >
            {remainingSeats > 0 ? (
              <>
                <CheckCircleFilled style={{ fontSize: 16 }} />
                {remainingSeats}
              </>
            ) : (
              <>
                <CloseCircleFilled style={{ fontSize: 16 }} />
                {remainingSeats}
              </>
            )}
          </span>
        </div>

        <div className="stat-item">
          <span className="stat-label">Plan</span>
          <span className="stat-value plan-name">{planName}</span>
        </div>

        <div className="stat-item">
          <span className="stat-label">Renews On</span>
          <span className="stat-value date-val">
            <CalendarOutlined style={{ color: "#0284c7", marginRight: 5 }} />
            {renewsOn}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSummaryBanner;
